import React from 'react';
import LoadingSpinner from '@/components/LoadingSpinner';
import { cn } from '@/lib/utils';

export function LoadingStatusPill({ text = 'Gegevens laden...', className = '' }) {
  return (
    <div className={cn('inline-flex items-center gap-2 rounded-lg border border-dd-line bg-dd-s1 px-3 py-2 text-xs text-dd-text', className)}>
      <LoadingSpinner size="sm" className="shrink-0" />
      <span>{text}</span>
    </div>
  );
}

export function SkeletonBlock({ className = '' }) {
  return <div className={cn('animate-pulse rounded-lg bg-dd-bg', className)} />;
}
